import PropTypes from 'prop-types';
import {
  Box,
  Checkbox,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Badge,
} from '@mui/material';
import React, {useState} from 'react';

import filterComp from '../../components/Filter/filterComp.module.css';
import {ReactComponent as ExpandMoreIcon} from '../../assets/images/dropdown-down.svg';
import {ReactComponent as ExpandLessRoundedIcon} from '../../assets/images/dropdown-up.svg';
import {ReactComponent as CustomUncheckedIcon} from '../../assets/images/check-off.svg';
import {ReactComponent as CustomCheckedIcon} from '../../assets/images/check-on.svg';
import SearchBox from '../../components/SearchBox/searchBox';

const SingleFilter = ({
  options,
  filterSelected,
  buttonName,
  filterKey,
  filterName,
  onFilterChange,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [tempSelected, setTempSelected] = useState([...filterSelected]);
  const open = Boolean(anchorEl);

  const handleMenuItemClick = (event, value) => {
    event.stopPropagation();
    setTempSelected(prevSelected => {
      if (prevSelected.includes(value)) {
        return prevSelected.filter(item => item !== value);
      } else {
        return [...prevSelected, value];
      }
    });
  };

  const handleClose = () => {
    setMenuOpen(false);
    setAnchorEl(null);

    // Update the parent state only when the dropdown is closed
    onFilterChange(tempSelected); // Send selected values to parent
  };

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
    setMenuOpen(true);
  };

  const handleSearchChange = event => {
    setSearchQuery(event.target.value);
  };

  const filteredOptions = options.filter(
    option =>
      option[filterName] &&
      option[filterName]
        .toLowerCase()
        .includes(searchQuery.trim().toLowerCase()),
  );

  return (
    <Box>
      <Grid container onClick={handleClick} className={filterComp.filterButton}>
        <Grid item>
          <Box className={filterComp.insideButton}>
            <span className="text-bold-14px">{buttonName}</span>
            {!menuOpen && filterSelected.length > 0 && (
              <Badge
                badgeContent={filterSelected.length}
                sx={{
                  '& .MuiBadge-badge': {
                    backgroundColor: '#F37021',
                    color: 'white !important',
                    fontSize: '10px',
                    minWidth: 'auto',
                    width: '20px',
                    height: '20px',
                    borderRadius: '50%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  },
                }}
              />
            )}
          </Box>
        </Grid>
        <Grid item>
          <IconButton size="small">
            {menuOpen ? <ExpandLessRoundedIcon /> : <ExpandMoreIcon />}
          </IconButton>
        </Grid>
      </Grid>

      <Menu
        anchorEl={anchorEl}
        className={filterComp.menu}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        PaperProps={{
          style: {
            maxHeight: 'auto',
            width: 'auto',
            boxShadow: 'none',
            border: '1px solid #ccc',
            borderRadius: '8px',
            padding: '0px',
            marginTop: '8px',
          },
        }}>
        <Box className={filterComp.search}>
          <SearchBox
            searchQuery={searchQuery}
            handleSearch={handleSearchChange}
          />
        </Box>

        <Box className={filterComp.menuItem}>
          {filteredOptions.map((option, index) => (
            <MenuItem
              key={index}
              onClick={event => handleMenuItemClick(event, option[filterKey])}>
              <Grid container className={filterComp.menuItem_container}>
                <Grid item>
                  <Box className="text-medium-14px">{option[filterName]}</Box>
                </Grid>
                <Grid item>
                  <Checkbox
                    className={filterComp.menu_checkbox}
                    checked={tempSelected.includes(option[filterKey])} // Use tempSelected state
                    onClick={event =>
                      handleMenuItemClick(event, option[filterKey])
                    }
                    value={option[filterKey]}
                    icon={<CustomUncheckedIcon />}
                    checkedIcon={<CustomCheckedIcon />}
                    sx={{
                      '& .MuiSvgIcon-root': {
                        color: '#96A6BE',
                      },
                      '&.Mui-checked .MuiSvgIcon-root': {
                        color: '#F37021',
                      },
                    }}
                  />
                </Grid>
              </Grid>
            </MenuItem>
          ))}
        </Box>
      </Menu>
    </Box>
  );
};

SingleFilter.propTypes = {
  filterType: PropTypes.string.isRequired,
  buttonName: PropTypes.string.isRequired,
  filterName: PropTypes.string.isRequired,
  filterKey: PropTypes.string.isRequired,
  options: PropTypes.any,
  onFilterChange: PropTypes.func.isRequired,
  filterSelected: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default SingleFilter;
